
import { defineComponent } from 'vue';
import appProzis from '@/Utilities/app-prozis-store';
export default defineComponent({
    props: {
        thumb: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        extraInfo: {
            type: [Object, String],
            default: null
        }
    },
    methods:{
        goto(){
            const info = this.extraInfo;
            if(info && typeof info === 'object' && info.sendEventApp){
                appProzis.call(info.eventName, JSON.stringify({
                    type: info.typeProfile,
                    id: info.profileId.toString(),
                    url: info.url,
                    openMode: info.openMode,
                    eventData: this.getAppEventData(),
                }));
            }else{
                this.$emit('click');
                if(this.url){
                    window.location.assign(this.url);
                }
            }
        },
        getAppEventData(){
            const mub = window.mub;
            const wrapper = this.$refs.wrapper;
            
            if(!mub || !wrapper){
                return null;
            }

            const d = JSON.parse(wrapper.dataset['mub']);
            return {
                rid: mub.rid,
                page: mub.page,
                block: d.b ? d.b : '',
                blockType: d.t ? d.t : '',
                blockMeta: d.m ? d.m : null,
            }
        },
    }
});
